
export default {
  data() {
    return {
      selectedOption: "item", // default selection
      orderLevelAmount: 0, // initial value for order level amount
      priceSlabConfiguration: [
        { label: "00-49", min: 0, max: 49, value: 0 },
        { label: "50-150", min: 50, max: 150, value: 2 },
        { label: "151-300", min: 151, max: 300, value: 0 },
        { label: "301-500", min: 301, max: 500, value: 15 },
        { label: "501+", min: 501, max: 1000, value: 0 }
      ]
    };
  },
  methods: {
    save() {
      // Handle save logic here
      console.log("Selected Option:", this.selectedOption);
      if (this.selectedOption === "item") {
        console.log("Item Level Charges:", this.priceSlabConfiguration);
      } else {
        console.log("Order Level Amount:", this.orderLevelAmount);
      }
    }
  }
};
